import { SimplifiedPricingModelEnum } from 'sonata-static-storage/lib/schemas/user/userDataFee.schema';

import {
  getHasUnsavedChanges as getHasUnsavedIOChanges,
  IoSettingsStore,
  useStore as useIOSettingsStore
} from '@/store/local/ioSettings';
import {
  getHasUnsavedChanges as getHasUnsavedLIChanges,
  LineItemStore,
  useStore as useLISettingsStore
} from '@/store/local/lineItem';
import { WizardLayout } from './wizardLayout';

type Props = {
  entityType: 'lineItem' | 'insertionOrder';
};

export function IOWizardLayout({ entityType }: Props) {
  const state = useIOSettingsStore() as IoSettingsStore;
  const { pricingModelConfig } = state;

  const pricingModel = pricingModelConfig.bidModels[0].bid.pricingModel;

  const isCpmPricingModel = pricingModel?.includes('cpm');
  const pricingModelEnum = isCpmPricingModel
    ? SimplifiedPricingModelEnum.cpm
    : SimplifiedPricingModelEnum[pricingModel as keyof typeof SimplifiedPricingModelEnum];

  return (
    <WizardLayout
      entityType={entityType}
      hasUnsavedChanges={getHasUnsavedIOChanges(state)}
      pricingModel={pricingModelEnum}
    />
  );
}

export function LIWizardLayout({ entityType }: Props) {
  const state = useLISettingsStore() as LineItemStore;
  const { pricingModelConfig } = state;

  const pricingModel = pricingModelConfig.bidModels[0].bid.pricingModel;

  const isCpmPricingModel = pricingModel?.includes('cpm');
  const pricingModelEnum = isCpmPricingModel
    ? SimplifiedPricingModelEnum.cpm
    : SimplifiedPricingModelEnum[pricingModel as keyof typeof SimplifiedPricingModelEnum];

  return (
    <WizardLayout
      entityType={entityType}
      hasUnsavedChanges={getHasUnsavedLIChanges(state)}
      pricingModel={pricingModelEnum}
    />
  );
}
